// 2-column grid of category tiles, used inside both FilterModal and
// WhereModal's "Serviciu" panel. Tile = icon stacked over label,
// single-select with an active outline + bg highlight. Mirrors the
// CategoryStrip's chip set 1:1 — the strip just lays them out as a
// horizontal scroll, the grid stacks them.
//
// Controlled component: parent owns the active id and the onChange
// callback. That keeps the modals free to use draft state (only
// commit on Apply) while the strip writes to the URL on every tap.

import { CATEGORIES } from './categories';

export default function CategoryGrid({ value, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {CATEGORIES.map((entry) => {
        const { Icon, label, id } = entry;
        const active = id === value;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange?.(entry)}
            aria-pressed={active}
            className={`flex flex-col items-center gap-2 rounded-2xl border-2 px-3 py-4 transition-all ${
              active
                ? 'border-ink bg-cream-100'
                : 'border-ink/15 bg-cream-50 hover:border-ink/40'
            }`}
          >
            <Icon className={`h-6 w-6 ${active ? 'text-ink' : 'text-ink-500'}`} aria-hidden="true" />
            <span className="text-center text-xs font-medium leading-tight text-ink">
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
